import * as React from "react";
import LoginForm from "../forms/LoginForm";
import { TypeAnimation } from 'react-type-animation';


function LoginPage() {
  return (
      <main
        className="flex flex-col lg:flex-row h-screen w-screen bg-[#000000]"
        style={{
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          overflow: "hidden", // Prevents scrolling both vertically and horizontally
        }}
      >
        {/* Left Section: Image with Gradient */}
        <header
          className="relative flex lg:h-full h-[50%]"
          style={{
            flexBasis: "58.61%",
            flexGrow: 1,
            position: "relative", // Ensure proper layering
          }}
        >
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            {/* <h1 style={{ fontSize: '3rem', color: '#fff', textAlign: 'center' }}>
              BAE Systems
            </h1>
            <TypeAnimation
              sequence={[
                '', // Initial empty string to start the typing effect
                1000, // Waits 1 second before starting
                'Trusted, Innovative, Bold', // Types the string
              ]}
              wrapper="h2"
              speed={30}
              style={{ fontSize: '2rem', color: '#fff', textAlign: 'center' }}
              repeat={0} // Ensures the animation does not loop
            /> */}
            <img src="/LLLGO.png"/>
          </div>
        </header>

        {/* Right Section: Login Form */}
        <section
          className="flex justify-center py-20 bg-bg text-font h-full"
          style={{
            flexBasis: "41.39%",
            flexShrink: 0,
          }}
        >
          <div className="w-3/4 py-10 pl-20">
            <LoginForm />
          </div>
        </section>
      </main>
  );
}

export default LoginPage;